import { CLEAR } from './const';

export default () => ({
  type: CLEAR,
  payload: null,
});
